import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=e406ec4c&scoped=true&"
import script from "./UserForm.js?vue&type=script&lang=js&"
export * from "./UserForm.js?vue&type=script&lang=js&"
import style0 from "./UserForm.scss?vue&type=style&index=0&id=e406ec4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e406ec4c",
  null
  
)

export default component.exports